var React = require('react');

function Ripple (props) {
    return React.createElement("svg",props,[React.createElement("ellipse",{"id":"1","data-name":"1","cx":"54.43","cy":"191.36","rx":"54.43","ry":"191.36","key":0}),React.createElement("ellipse",{"id":"2","data-name":"2","cx":"167.03","cy":"194.19","rx":"39.15","ry":"159.18","key":1}),React.createElement("ellipse",{"id":"3","data-name":"3","cx":"253.38","cy":"194.53","rx":"28.72","ry":"135.04","key":2}),React.createElement("ellipse",{"id":"4","data-name":"4","cx":"314.43","cy":"194.67","rx":"14.06","ry":"109.09","key":3}),React.createElement("ellipse",{"id":"5","data-name":"5","cx":"366.04","cy":"194.75","rx":"6.14","ry":"80.93","key":4})]);
}

Ripple.defaultProps = {"id":"ripple","data-name":"ripple","viewBox":"0 0 372.18 382.73"};

module.exports = Ripple;

Ripple.default = Ripple;
